const enum Status {
	Idle = 'idle',
	Loading = 'loading',
	Succeeded = 'succeeded',
	Failed = 'failed',
}

export default Status;
